import { Outlet } from 'react-router-dom';

import { PageDetailContent } from '@client/toolkit';

import { SpaceAssociationsCard } from './space-associations-card.component';
import { PageContentAnimation } from '../../../../../components/layout/page-content-animation';

export function SpaceAssociationsRoute() {
  return (
    <>
      <PageDetailContent align="left">
        <PageContentAnimation>
          <SpaceAssociationsCard />
        </PageContentAnimation>
      </PageDetailContent>
      <Outlet />
    </>
  );
}
